import { Filter } from "./filter";

export class ById extends Filter {
  constructor(public id: number) {
    super("by.id");
  }
}
